import { render, staticRenderFns } from "./GuestListMain.vue?vue&type=template&id=022a0f8c&"
import script from "./GuestListMain.vue?vue&type=script&lang=js&"
export * from "./GuestListMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports